/* eslint-disable no-unused-expressions */
import {
  Autocomplete,
  Chip,
  ClickAwayListener,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

const AutoCompleteTags = (props) => {
  const { label, name, options, formik, required, ...rest } = props;
  const [valueForClickAway, setValueForClickAway] = useState();
  const [originalValue, setOriginalValue] = useState([]);
  const handleChange = (value) => {
    let x;
    setOriginalValue(value);
    value.length > 0 &&
      ((value[value.length - 1] = value[value.length - 1].toUpperCase()),
      setOriginalValue(value));
    if (valueForClickAway) {
      x = [...originalValue, valueForClickAway.toUpperCase()];
    } else {
      x = value;
    }
    formik.setFieldValue(name, x);
  };

  return (
    <div>
      <InputLabel
        htmlFor="autocomplete-tags-name"
        sx={{
          marginBottom: "15px",
          textAlign: "left",
          textStyle: "none",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontWeight: required ? "bold" : "500",
          }}
        >
          {label}
        </Typography>
      </InputLabel>
      <ClickAwayListener onClickAway={() => handleChange(originalValue)}>
        <Autocomplete
          sx={{ minWidth: 250, maxWidth: 320 }}
          onChange={(_, value) => handleChange(value)}
          onInputChange={(_, value) => setValueForClickAway(value)}
          multiple
          filterSelectedOptions
          size="small"
          id="autocomplete-tags-name"
          options={options}
          freeSolo
          {...rest}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                key={option}
                variant="outlined"
                label={option.toUpperCase()}
                {...getTagProps({ index })}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              sx={{ paddingRight: "30px" }}
              {...params}
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
      </ClickAwayListener>
    </div>
  );
};

export default AutoCompleteTags;
